import { render, staticRenderFns } from "./AsignacionesConvenioRecauda.vue?vue&type=template&id=451deb87"
import script from "./AsignacionesConvenioRecauda.vue?vue&type=script&lang=js"
export * from "./AsignacionesConvenioRecauda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports